var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6326 94.1613C58.5475 95.2796 36.4524 95.2796 14.3672 94.1613C7.34833 93.7819 1.21808 87.6516 0.838676 80.6327C-0.279559 58.5476 -0.279559 36.4524 0.838676 14.3673C1.21808 7.34839 7.34833 1.21808 14.3672 0.838676C36.4524 -0.279559 58.5475 -0.279559 80.6326 0.838676C87.6516 1.21808 93.7819 7.34839 94.1613 14.3673C95.2796 36.4524 95.2796 58.5476 94.1613 80.6327C93.7819 87.6516 87.6516 93.7819 80.6326 94.1613Z",
    fill: "#28AD7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9343 46.5066C66.9343 43.9007 64.8177 41.794 62.2218 41.794H59.8656V34.7152C59.8656 28.2155 54.5738 22.9238 48.0741 22.9238C41.5744 22.9238 36.2828 28.2155 36.2828 34.7152V41.794H33.9265C31.3206 41.794 29.2139 43.9107 29.2139 46.5066V65.3768C29.2139 67.9827 31.3306 70.0894 33.9265 70.0894H62.2318C64.8377 70.0894 66.9443 67.9727 66.9443 65.3768V46.5066H66.9343ZM40.9953 34.7152C40.9953 30.8114 44.1703 27.6364 48.0741 27.6364C51.9779 27.6364 55.1529 30.8114 55.1529 34.7152V41.794H41.0053V34.7152H40.9953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.e2383cbcc4c94235de34132d0cdc5b50.svg";
export { ForwardRef as ReactComponent };